package com.bulut.mecitogullari.data.repository

import com.bulut.mecitogullari.data.model.Project
import kotlinx.coroutines.flow.Flow

interface ProjectRepository {
    val projects: Flow<List<Project>>
    suspend fun getProject(projectId: String): Project?
    suspend fun createProject(project: Project)
    suspend fun updateProject(project: Project)
    suspend fun deleteProject(projectId: String)
}

class FirestoreProjectRepository : ProjectRepository {

    override val projects: Flow<List<Project>> = userCollectionFlow(COLLECTION)

    override suspend fun getProject(projectId: String): Project? {
        val uid = currentUid() ?: return null
        val snapshot = userCollection(uid, COLLECTION).document(projectId).get()
        return if (snapshot.exists) runCatching { snapshot.data<Project>() }.getOrNull() else null
    }

    override suspend fun createProject(project: Project) {
        upsert(project)
    }

    override suspend fun updateProject(project: Project) {
        upsert(project)
    }

    override suspend fun deleteProject(projectId: String) {
        val uid = currentUid() ?: return
        userCollection(uid, COLLECTION).document(projectId).delete()
    }

    private suspend fun upsert(project: Project) {
        val uid = currentUid() ?: return
        userCollection(uid, COLLECTION).document(project.id).set(project)
    }

    private companion object {
        const val COLLECTION = "projects"
    }
}
